import { useOutletContext } from 'react-router-dom';
import type { Event } from '@/types/event';

interface EventContextType {
  event: Event | undefined;
  isLoading: boolean;
}

/**
 * Hook to access the event detail context from tab components.
 * @returns Event data and loading state from the parent detail page
 */
export function useEventContext(): EventContextType {
  return useOutletContext<EventContextType>();
}
